































































































































import Vue from "vue";

export default Vue.extend({
  data() {
    return {
      enlacePagosImagen: "/images/enlace-pagos.png",
      enlacePagos: "https://ruah.unicesmag.edu.co/generar-recibos-pagos",
    };
  },
});
